import { render } from "./2022-10-27-Ajax.md?vue&type=template&id=f391c536"
const script = {}
script.render = render

export default script